import React, {Component} from 'react';
import Aux from '../Hoc/Aux.js';

class CustomerConnect extends Component {
  render () {
    return (
      <Aux>
        <span className='visit'> or visit us<br /> at one of our <a href='https://www.cdphp.com/customer-support/customer-connect' target='_blank' rel='noopener noreferrer'>Customer Connect&nbsp;locations</a>.
        </span>
      </Aux>
    );
  }
}
export default CustomerConnect;
